import { render, staticRenderFns } from "./RowMarket.vue?vue&type=template&id=b3e897b8"
import script from "./RowMarket.vue?vue&type=script&lang=js"
export * from "./RowMarket.vue?vue&type=script&lang=js"
import style0 from "./RowMarket.vue?vue&type=style&index=0&id=b3e897b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports